import EpicLayout from './EpicLayout';

export default EpicLayout;